var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"tab-section",attrs:{"collapsible":false,"title":_vm.title,"subTitle":_vm.subTitle,"tag":_vm.tag}},[_c('div',{staticClass:"tabTitle"},[_vm._v(_vm._s(_vm.tabTitle))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }